import { CountryInfo, ProvinceInfo, CountryCode } from './geo.types';

export const DEFAULT_COUNTRY_CODE: CountryCode = 'CA';

export const countries: Array<CountryInfo> = [
  {
    code: 'CA',
    name: 'Canada'
  },
  // Decided to only include Canada for now.
  // {
  //   code: 'US',
  //   name: 'United States of America'
  // }
];

export const provinces: Array<ProvinceInfo> = [
  {
    country: 'CA',
    code: 'ON',
    name: 'Ontario'
  },
  {
    country: 'CA',
    code: 'BC',
    name: 'British Columbia'
  },
  {
    country: 'CA',
    code: 'AB',
    name: 'Alberta'
  },
  {
    country: 'CA',
    code: 'MB',
    name: 'Manitoba'
  },
  {
    country: 'CA',
    code: 'NB',
    name: 'New Brunswick'
  },
  {
    country: 'CA',
    code: 'NL',
    name: 'Newfoundland and Labrador'
  },
  {
    country: 'CA',
    code: 'NT',
    name: 'Northwest Territories'
  },
  {
    country: 'CA',
    code: 'NS',
    name: 'Nova Scotia'
  },
  {
    country: 'CA',
    code: 'NU',
    name: 'Nunavut'
  },
  {
    country: 'CA',
    code: 'PE',
    name: 'Prince Edward Island'
  },
  {
    country: 'CA',
    code: 'QC',
    name: 'Quebec'
  },
  {
    country: 'CA',
    code: 'SK',
    name: 'Saskatchewan'
  },
  {
    country: 'CA',
    code: 'YK',
    name: 'Yukon'
  },
  // Decided to only include Canada for now.
  // {
  //   country: 'US',
  //   code: 'NY',
  //   name: 'New York'
  // }
];


// WEBPACK FOOTER //
// ./src/geo/geo.const.tsx